export const getErrorStatusCode = (error) =>
  error?.graphQLErrors[0]?.extensions?.response?.status.toString()
